import axiosInstance from '../../config';
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CurrencyFormat from 'react-currency-format';
import '../../styles/styles.css';
import { useHistory } from 'react-router-dom';
import Pagination from "@material-ui/lab/Pagination";
import Navbar from '../../components/Navbar';
import WriteoffModal from '../../components/WriteoffModal';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  border: {
    '& td': {
      borderBottom: '1px solid black !important',
    },
  },
  borderInactive: {
    backgroundColor: '#e1e1e1',
    '& td': {
      borderBottom: '1px solid black !important',
    },
  },
  pointer: {
    cursor: 'pointer',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '0.3rem 0',
  },
}));

const Writeoff = ({ User }) => {
  const classes = useStyles();
  const [reports, setReports] = useState([]);
  const [selected, setSelected] = useState(null);
  const [open, setOpen] = useState(null);
  const [totalPage, setTotalPage] = useState(null);
  const [pageNo, setPageNo] = useState(null);
  const history = useHistory();
  const handleChange = (e, page) => {
    if (e != null) e.preventDefault();
    axiosInstance
      .get('agent/balReport/player/writeoff', {
        params: {
          pageNo: isNaN(page) ? null : page - 1,
        },
      })
      .then((res) => {
        setPageNo(res.data.pageable.pageNo);
        setTotalPage(res.data.totalPages);
        setReports(res.data.content);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          history.push('/');
        }
      });
  };

  useEffect(() => {
    handleChange(null);
  }, []);

  return (
    <>
      <Navbar User={User} />
        <div className="d-flex justify-content-between my-3 px-3 align-items-center ">
        <form
          action=""
          className="form-inline"
          id="maxForm"
          onSubmit={handleChange}
        >
          {/* <label
            htmlFor="login"
            className="text-body font-weight-bold mx-2"
          >
            Player WriteOff{' '}
          </label> */}
          {/* <input
            type="text"
            id="login"
            className="form-control form-control-xs"
          /> */}
          {/* &nbsp;&nbsp;&nbsp;
          <input
            type="submit"
            value="Search"
            className="btn btn-sm btn-primary px-3 py-1 "
          /> */}
          {/* &nbsp;&nbsp;&nbsp; */}
        </form>
        <button
          className="btn btn-sm btn-primary px-3 py-1 "
          onClick={() => {
            setSelected(null);
            setOpen(true);
          }}
        >
          Create
        </button>
      </div>
      
        <div className="table-responsive-sm mx-2">
          <table className="table table-sm table-hover table-bordered">
            <thead className="text-center thead-dark">
              <tr>
                <th scope="col">No</th>
                <th scope="col">Login ID</th>
                <th scope="col">Created By</th>
                <th scope="col">Created At</th>
                <th scope="col">Balance</th>
                <th scope="col">Report Balance</th>
                <th scope="col">Remarks</th>
              </tr>
            </thead>
            {reports.length > 0 ? (
            <tbody>
              {reports.map((info, index) => (
                <tr key={index}>
                  <td className="text-dark text-left">{index + 1}</td>
                  <td className="text-dark text-center">{info.transaction.account.username}</td>
                  <td className="text-dark text-center">{info.createdBy}</td>
                  <td className="text-dark text-center">{moment(info.createdAt).format('DD/MM/yyyy HH:mm:ss')}</td>
                  <td className={`text-right`}>
                    <CurrencyFormat
                      value={info.balance ? info.balance : 0}
                      decimalScale={2}
                      displayType={'text'}
                      thousandSeparator={true}
                      fixedDecimalScale={true}
                      className={info.balance < 0? 'text-danger':''}
                    />
                  </td>
                  <td className={`text-right`}>
                    <CurrencyFormat
                      value={info.reportBalance ? info.reportBalance: 0}
                      decimalScale={2}
                      displayType={'text'}
                      thousandSeparator={true}
                      fixedDecimalScale={true}
                      className={info.reportBalance < 0? 'text-danger':''}
                    />
                  </td>
                  <td className="text-dark text-center">{info.remarks}</td>
                </tr>
              ))}
            </tbody>
            ) : null}
          </table>
          <Pagination
            count={totalPage}
            onChange={handleChange}
            className={classes.pagination}
            page={pageNo}
          />
        </div>
      
      <WriteoffModal
        cashModal={open}
        setCashModal={setOpen}
        refresh={handleChange}
      />
    </>
  );
};

export default Writeoff;
